import React from 'react';

export const ReserveConfirmOutlineBox: React.FC = ({ children }) => {
  return <div style={{ marginTop: '-1px', border: '1px solid #d1d5db' }}>{children}</div>;
};

export const ReserveConfirmOutlineBoxTitle: React.FC = ({ children }) => {
  return <div style={{ padding: '10px', fontWeight: 'bold', backgroundColor: '#f9fafb' }}>{children}</div>;
};
